import { Box, Typography } from '@mui/material'
import React from 'react'
import DiscoverdAssetsTable from '../../../../components/charts/DiscoverdAssetsTable';
import Weaknesses from '../../../../components/charts/Weakness';
import BarChart from '../../../../components/charts/Bar';

export default function DiscoveredAssetsExport({
    discoveredAssetsData,
    export: isExport

}) {

    const chartData = discoveredAssetsData.map((item) => {
        // Calculate the count of assets in this category
        const assetCount = item.discovered_assets.length;
        
        // Calculate the sum of all asset values in this category
        const totalAssetValue = item.discovered_assets.reduce(
          (sum, asset) => sum + asset.asset_value, 
          0
        );
        
        return {
          Title: item.category, 
          "Total Asset Value": totalAssetValue ,             // Use 'category' as the label (x-axis)
          "Total Number of Assets": assetCount,         // First dataset: Number of assets
           // Second dataset: Sum of asset values
        };
      });

  return (
    <Box sx={{ bgcolor: "#f9f9f9"}}>
        <Box
            key={1}
            id={`tlm-threat-1`} // Unique ID for each threat
            sx={{
                //   height: "297mm", // A4 height
                width: "210mm", // A4 width
                margin: "auto", // Center the box horizontally
                marginBottom: "20px",
                pageBreakAfter: "always", // Ensure each box starts on a new page in the PDF
                boxShadow: 3,
                borderRadius: 2,
                bgcolor: "#f9f9f9",
                padding: "20px", // Add padding inside the box
                boxSizing: "border-box", // Include padding in the total width/height
                overflow: "hidden", // Prevent content from overflowing
            }}
        >
        
 
    
            {/* Threat Title */}
            <Typography
                sx={{
                textAlign: "start",
                fontWeight: "bold",
                }}
                variant='h6'
            >
                1.2 Discovered Assets
            </Typography>

            <Typography sx={{textAlign: "start",fontSize: "0.875rem", marginBottom: "10px" }}>
                    {`This section presents a comprehensive overview of the organization's discovered assets, their categorization, and estimated values. The graph illustrates the distribution of assets across various categories, providing a visual representation of the company's asset landscape. The accompanying table offers a detailed breakdown of individual assets, including their estimated values and associated subdomains or systems where applicable.
 
It's crucial to note that these assets were identified solely through external attack surface scans, representing publicly exposed elements of the organization's infrastructure. The categorization and valuation of assets are theoretical and may not precisely reflect their true importance or value to the company. This approach is necessitated by limited internal information and should be considered a starting point for more in-depth analysis. While this assessment provides valuable insights into potential vulnerabilities and critical assets, the actual significance and sensitivity of these assets may differ from what is presented here. A more comprehensive internal audit would be required to validate and refine these findings, ensuring a more accurate representation of the organization's asset landscape and associated risks.`
                    .replace(/\. /g, '.\n\n')}
                </Typography>

            {/* top pie */}
            <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "center",
                alignItems: "center",
                gap: { xs: 2, sm: 4 },
                mt: 4,
                px: { xs: 1, sm: 2 },
            }}
            >
                <Box
                    sx={{
                    boxShadow: 3,
                    borderRadius: 2,
                    p: { xs: 2, sm: 3 },
                    bgcolor: "background.paper",
                    width: { xs: "90%", sm: "90%", md: "90%" },
                    minHeight: "450px",
                    height: "auto",
                    textAlign: "center",
                    }}
                >
                    <BarChart
                        data={chartData}
                        xKey="Title" // Use "Title" as your x-axis key (category names)
                        // xLabel="Category"
                        // yLabel="Average Asset Value"
                        title="Discovered company asset by category"
                        stacked={false} // Set to false for a simple bar chart
                        horizontal={true} // Set to false for vertical bars
                    />
                </Box>


            </Box>

            <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "row", sm: "row" },
                justifyContent: "center",
                alignItems: "center",
                
                mt: 4,
                px: { xs: 1, sm: 2 },
            }}
            >
            <Box
                    sx={{
                    boxShadow: 3,
                    borderRadius: 2,
                    p: { xs: 2, sm: 3 },
                    bgcolor: "background.paper",

                    height: "auto",
                    textAlign: "center",
                    }}
                >
                    <DiscoverdAssetsTable data={discoveredAssetsData} export={isExport} />
                </Box>
            </Box>
        </Box>
    </Box>
  )
}
